import iconDanger from '@/assets/landing/caution/icon-danger.svg'
import iconInfo from '@/assets/landing/caution/icon-info.svg'

import { CautionItem } from './CautionItem'
import { CautionContainer, CautionGroup, CautionLine } from './styles'

export function CautionSection() {
  return (
    <CautionContainer>
      <CautionGroup>
        <CautionItem
          variant='info'
          icon={iconInfo}
          title='배송지 안내'
        >
          <CautionLine variant='info'>
            오늘수거 <strong>앱에 등록된 대표 주소</strong>로 자동 설정 됩니다. 다른 주소로 받고 싶다면 결제 전 반드시
            수정해주세요.
          </CautionLine>
        </CautionItem>

        <CautionItem
          variant='danger'
          icon={iconDanger}
          title='환불 불가 안내'
        >
          <CautionLine variant='danger'>
            본 상품은 단순 변심에 의한 환불이 불가하니, 제품을 충분히 확인한 후, 동의하시는 경우에만 구매해 주세요.
          </CautionLine>
        </CautionItem>
      </CautionGroup>
    </CautionContainer>
  )
}
